import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import ReactSortableTree from 'react-sortable-tree';

import {
  addForm,
  showAddFormModal,
  hideAddFormModal,
  hideDeleteFormModal,
  showDeleteFormModal,
  deleteFormFromTree,
  showOwnershipModal,
  hideOwnershipModal,
  takeQueueItem,
  hideImyTreeWithholding
} from 'actions';
import { ApiService } from 'services';

import { history } from 'containers/App';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import NotFoundPage from 'components/Errors/NotFoundPage';
import DeleteFormModal from 'components/Modals/DeleteFormModal';
import AddFormModal from 'components/Modals/AddFormModal';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import { FormViewButton } from 'components/Common/Buttons/FormViewButton';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class VisualiseW8Imy extends React.PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        formId: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    settings: PropTypes.shape({
      showWithholding: PropTypes.bool
    }),
    isAddFormModalShown: PropTypes.bool.isRequired,
    showRate: PropTypes.bool,
    isDeleteFormModalShown: PropTypes.bool,
    isDeletingForm: PropTypes.bool,
    deleteFormError: PropTypes.string,
    deleteFormResponse: PropTypes.number,
    formsToDelete: PropTypes.shape(),
    isOwnershipModalShown: PropTypes.bool,
    changeOwnershipItem: PropTypes.shape(),
  };

  static defaultProps = {
    permissions: null,
    settings: null,
    isDeleteFormModalShown: false,
    showRate: false,
    isDeletingForm: false,
    deleteFormError: null,
    deleteFormResponse: null,
    formsToDelete: null,
    isOwnershipModalShown: false,
    changeOwnershipItem: null
  };

  static styleNodes(showIncomeAllocationAttrib) {
    const titles = [...document.querySelectorAll('.rst__rowTitle')];
    if (titles != null && titles.length > 0) {
      titles.forEach((title) => {
        if (title != null) {
          title.innerHTML = title.innerHTML.replace(/DIVSTART/g, '<span class="rst__rowTitleItem">');
          title.innerHTML = title.innerHTML.replace(/DIVEND/g, '</span>');
          // eslint-disable-next-line
          title.innerHTML = title.innerHTML.replace(/IMYSTART/g, '<div class="rst__rowRates rst__rowImyRates"><h2>Blended Rates</h2><div class="rst_colHeaders rst__rowIncomeType"><span class="rst__typeLabel">Income Type</span><span class="rst__colStmtAlloc">Stmt Income Alloc.</span><span class="rst__colBldRate">Blended Rate</span><span class="rst__colAlloc">Income Alloc.</span><span class="rst__colSc">California</span><span class="rst__colSm">Maine</span></div>');
          title.innerHTML = title.innerHTML.replace(/IMYEND/g, '</div>');
          title.innerHTML = title.innerHTML.replace(/BLDRATESTART/g, '<span class="rst__colBldRate">');
          title.innerHTML = title.innerHTML.replace(/BLDRATEEND/g, '</span>');
          // eslint-disable-next-line
          title.innerHTML = title.innerHTML.replace(/BOSTART/g, '<div class="rst__rowRates rst__rowBoRates"><br><h2>Breakout Rates</h2><div class="rst_colHeaders rst__rowIncomeType"><span class="rst__typeLabel">Income Type</span><span class="rst__colStmtAlloc">Stmt Income Alloc.</span><span class="rst__colRate">Stmt Rate</span><span class="rst__colAlloc">Income Alloc.</span><span class="rst__colBr">Breakout</span><span class="rst__colSc">California</span><span class="rst__colSm">Maine</span></div>');
          title.innerHTML = title.innerHTML.replace(/BOEND/g, '</div>');
          title.innerHTML = title.innerHTML.replace(/ITSTART/g, '<div class="rst__rowIncomeType">');
          title.innerHTML = title.innerHTML.replace(/ITEND/g, '</div>');
          title.innerHTML = title.innerHTML.replace(/LABELSTART/g, '<span class="rst__typeLabel">');
          title.innerHTML = title.innerHTML.replace(/LABELEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/STMTALLOCSTART/g, '<span class="rst__colStmtAlloc">');
          title.innerHTML = title.innerHTML.replace(/STMTALLOCEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/RATESTART/g, '<span class="rst__colRate">');
          title.innerHTML = title.innerHTML.replace(/RATEEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/SCSTART/g, '<span class="rst__colSc">');
          title.innerHTML = title.innerHTML.replace(/SCEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/SMSTART/g, '<span class="rst__colSm">');
          title.innerHTML = title.innerHTML.replace(/SMEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/ALLOCSTART/g, '<span class="rst__colAlloc">');
          title.innerHTML = title.innerHTML.replace(/ALLOCEND/g, '</span>');
          title.innerHTML = title.innerHTML.replace(/BRSTART/g, '<span class="rst__colBr">');
          title.innerHTML = title.innerHTML.replace(/BREND/g, '</span>');
        }
      });
      titles.forEach((title) => {
        if (title != null) {
          const children = Array.from(title.children);
          if (children != null && children.length > 0) {
            for (let i = 1; i < children.length; i += 1) {
              if (children[i] != null) {
                children[i].classList.add('rst__rowSubTitle');
                if (!showIncomeAllocationAttrib && children[i].innerHTML.startsWith('Income Allocation:')) {
                  children[i].setAttribute('style', 'display:none;');
                }
              }
            }
          }
        }
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      rawData: null,
      data: null,
      treeError: null,
      displayMode: 'imyOnly',
      showWithholding: false,
      displayWithholdingOption: props.settings && props.settings.showWithholding
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    this.fetchTree();
  }

  componentDidUpdate(prevProps, prevState) {
    const { deleteFormResponse, isDeletingForm } = this.props;
    const { data, displayWithholdingOption } = this.state;

    if (prevProps.isDeletingForm && !isDeletingForm
      && prevProps.deleteFormResponse === null && deleteFormResponse !== null
      && (data == null || data.length === 0 || data[0] == null || data[0].id == null || parseInt(data[0].id, 0) !== deleteFormResponse)) {
      this.fetchTree();
    }

    if (prevState.data !== data && data != null) {
      setTimeout(() => VisualiseW8Imy.styleNodes(!displayWithholdingOption), 0);
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(hideImyTreeWithholding());
    dispatch(hideOwnershipModal());
  }

  onTitleClick(node) {
    const { dispatch, permissions } = this.props;

    const wfStatus = node.workflowStatus != null && node.workflowStatus.toLowerCase();
    const form = {
      id: node.id,
      formType: node.formType.toLowerCase(),
      workflowStatus: node.workflowStatus,
      workflowUsername: node.workflowUsername,
      workflowUserFullName: node.workflowUserFullName
    };
    if (FormViewButton.isUserFormOwner(node.workflowUsername) || wfStatus === 'complete') {
      history.push(`/forms/${ node.formType }/${ node.id }`);
    } else if (FormViewButton.showModal(permissions, form)) {
      dispatch(showOwnershipModal({
        id: form.id,
        formType: form.formType,
        currentUser: form.workflowUsername,
        currentUserFullName: form.workflowUserFullName
      }));
    } else {
      if (wfStatus.includes('initial') && AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer])) {
        dispatch(takeQueueItem('form', form.id));
      }

      if (wfStatus.includes('secondary') && AccessControl.hasPermission(permissions, [ActivityPerms.fwfSecondaryReviewer])) {
        dispatch(takeQueueItem('form', form.id));
      }
    }
  }

  getRowHeight() {
    const { showWithholding, displayWithholdingOption } = this.state;
    if (showWithholding) {
      return 245;
    }
    return displayWithholdingOption ? 155 : 175;
  }

  scroll = () => {
    const { displayWithholdingOption } = this.state;
    setTimeout(() => VisualiseW8Imy.styleNodes(!displayWithholdingOption), 0);
  }

  fetchTree() {
    const { match, showRate, settings } = this.props;
    let { displayMode } = this.state;

    const addMissingFields = (obj) => {
      if (obj != null) {
        if (obj.name != null) {
          obj.title = `DIVSTART${ (obj.name.length <= 40 ? obj.name : `${ obj.name.substring(0, 39) }...`) }DIVEND`;
        } else {
          obj.title = 'DIVSTARTNADIVEND';
        }
        obj.expanded = true;
        obj.canAddLayers = obj.id && obj.formType != null && obj.formType.startsWith('w8imy');

        if (obj.attributes != null) {
          // eslint-disable-next-line no-restricted-syntax
          for (const attr in obj.attributes) {
            if (obj.attributes[attr] != null) {
              obj.title += `DIVSTART${ attr }: ${ (obj.attributes[attr].length <= 40 ? obj.attributes[attr] : `${ obj.attributes[attr].substring(0, 39) }...`) }DIVEND`;
            }
          }
        }

        if (obj.rates != null && obj.rates.length > 0) {
          const tagStart = (obj.formType != null && obj.formType.indexOf('imy') !== -1) ? 'IMY' : 'BO';
          if ((tagStart === 'IMY' || tagStart === 'BO') && obj.valid && obj.workflowComplete) {
            obj.title += `${ tagStart }START`;
            // eslint-disable-next-line no-restricted-syntax
            for (const rateIndex in obj.rates) {
              if (obj.rates[rateIndex] != null) {
                const rate = obj.rates[rateIndex];
                if (obj.formType != null && obj.formType.indexOf('imy') !== -1) {
                  obj.title += `ITSTARTLABELSTART${ rate.incomeType }LABELENDSTMTALLOCSTART${ rate.stmtIncomeAllocation }STMTALLOCENDBLDRATESTART`
                  + `${ rate.blendedRate }BLDRATEENDALLOCSTART${ rate.blendedIncomeAllocation }ALLOCENDSCSTART${ rate.blendedCalifornia }SCENDSMSTART${ rate.blendedMaine }SMENDITEND`;
                } else {
                  obj.title += `ITSTARTLABELSTART${ rate.incomeType }LABELENDSTMTALLOCSTART${ rate.stmtIncomeAllocation }STMTALLOCENDRATESTART${ rate.rate }RATEENDALLOCSTART`
                  + `${ rate.incomeAllocation }ALLOCENDBRSTART${ rate.breakoutRate }BRENDSCSTART${ rate.california }SCENDSMSTART${ rate.maine }SMENDITEND`;
                }
              }
            }
            obj.title += `${ tagStart }END`;
          }

          this.setState({
            displayWithholdingOption: settings && settings.showWithholding,
            showWithholding: showRate && settings && settings.showWithholding
          });
        }
      }
    };

    ApiService
      .getW8ImyTreeStructure(match.params.formId)
      .then((result) => {
        const { data } = result;
        addMissingFields(data);
        const root = {
          id: match.params.formId,
          name: data.name,
          formType: data.formType,
          valid: data.valid,
          isFFI: data.isFFI,
          taxRegimeType: data.taxRegimeType,
          customerId: data.customerId,
          title: data.title,
          workflowStatus: data.workflowStatus,
          workflowUsername: data.workflowUsername,
          workflowUserFullName: data.workflowUserFullName,
          workflowPhase: data.workflowPhase,
          children: data.children,
          canAddLayers: data.id && data.formType != null && data.formType.startsWith('w8imy'),
          expanded: true
        };
        const transform = (array) => {
          array.forEach((item) => {
            if (item != null) {
              addMissingFields(item);
              if (item.children != null) {
                transform(item.children);
              }
            }
          });
        };
        transform(root.children);

        if (root.id !== result.data.formIdRequested) {
          displayMode = 'all';
        }

        this.setState({ displayMode, rawData: [root] });

        if (displayMode === 'imyOnly') {
          let imys = JSON.parse(JSON.stringify(root));
          imys = this.filterImys([imys]);
          this.setState({ data: [imys[0]] }, () => VisualiseW8Imy.styleNodes(!settings.showWithholding));
        } else {
          this.setState({ data: [root] }, () => VisualiseW8Imy.styleNodes(!settings.showWithholding));
        }
      }).catch((err) => {
        if (err.response && err.response.data) {
          this.setState({ data: null, treeError: err.response.data });
        } else {
          this.setState({
            data: null,
            treeError: {
              code: 502,
              message: 'Sorry, there was a problem getting the W-8IMY tree structure'
            }
          });
        }
      });
  }

  openAddFormModal(item) {
    const { dispatch } = this.props;
    dispatch(showAddFormModal(item, false));
  }

  addForms(parentForm, values, onlineForm) {
    const { dispatch } = this.props;
    dispatch(addForm(parentForm, values, onlineForm));
  }

  closeAddFormModal(item) {
    const { dispatch } = this.props;
    dispatch(hideAddFormModal(item));
    this.fetchTree();
  }

  closeDeleteFormModal() {
    const { dispatch } = this.props;
    dispatch(hideDeleteFormModal());
  }

  openDeleteFormModal(item) {
    const { dispatch } = this.props;
    dispatch(showDeleteFormModal(item));
  }

  deleteForm() {
    const { dispatch, match, formsToDelete: { formType, id } } = this.props;
    const { data } = this.state;
    const redirectAfterDelete = (!data || (data.length === 1 && data[0].id === id) || parseInt(match.params.formId, 10) === id);
    dispatch(deleteFormFromTree(formType, id, redirectAfterDelete));
  }

  filterImys(forms) {
    const { showWithholding } = this.state;
    const r = forms.filter((o) => {
      if (o.children) o.children = this.filterImys(o.children);
      return ((o.formType != null && o.formType.startsWith('w8imy')) || (o.name === 'Unknown Recipient' && showWithholding));
    });
    return r;
  }

  findForm(currentNode, name) {
    if (currentNode != null) {
      if (name === currentNode.name) {
        return currentNode;
      }
      if (currentNode.children != null) {
        // Use a for loop instead of forEach to avoid nested functions
        // Otherwise "return" will not work properly
        for (let i = 0; i < currentNode.children.length; i += 1) {
          const currentChild = currentNode.children[i];
          let result = null;
          if (currentChild != null) {
            // Search in the current child
            result = this.findForm(currentChild, name);
          }
          // Return the result if the node has been found
          if (result != null) {
            return result;
          }
        }
      }
      // The node has not been found and we have no more options
      return null;
    }
    return null;
  }

  toggleDisplayMode() {
    const { rawData, data, displayWithholdingOption } = this.state;
    this.setState((prevState) => {
      if (prevState.displayMode === 'imyOnly') {
        return {
          displayMode: 'all',
          data: rawData
        };
      }

      let imys = JSON.parse(JSON.stringify(rawData));
      imys = this.filterImys(imys);
      return {
        displayMode: 'imyOnly',
        data: imys
      };
    }, () => {
      if (data && data[0]) {
        VisualiseW8Imy.styleNodes(!displayWithholdingOption);
      }
    });
  }

  toggleShowWithholding() {
    const { showWithholding } = this.state;
    this.setState({
      showWithholding: !showWithholding
    }, () => {
      this.refreshData();
    });
  }

  refreshData() {
    const { displayMode, rawData } = this.state;
    let imys = JSON.parse(JSON.stringify(rawData));
    if (displayMode === 'imyOnly') {
      imys = this.filterImys(imys);
    }
    this.setState({
      data: imys
    });
  }

  reAssignItem() {
    const { dispatch, changeOwnershipItem } = this.props;

    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id));
      dispatch(hideOwnershipModal());
    }
  }

  continueFromOwnershipModal() {
    const { dispatch, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    history.push(`/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`);
  }

  closeFromOwnershipModal() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  render() {
    const {
      data,
      displayMode,
      showWithholding,
      displayWithholdingOption,
      treeError,
    } = this.state;
    const {
      isAddFormModalShown,
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      isOwnershipModalShown,
      changeOwnershipItem
    } = this.props;

    return (
      <div className="visualise-w8-imy" style={ { height: 2000 } } onScroll={ e => this.scroll(e) }>
        { treeError && (treeError.code !== 0
          ? <NotFoundPage caption="The tree was not found" />
          : <div className="toast toast-error">
            { treeError.message }
          </div>) }
        { !treeError && <div id="rst__displayModeContainer" className="rst-options">
          <div className="form">
            <div className="form-group">
              <h4>Display Options:</h4>
              <label className="form-label" htmlFor="displayMode">
                <input id="displayModeAll" type="radio" name="displayMode" value="all" className="form-control" onChange={ () => this.toggleDisplayMode() } checked={ displayMode === 'all' } />
                View All
              </label>
              <label className="form-label" htmlFor="displayModeImy">
                <input id="displayModeImy" type="radio" name="displayMode" value="imyOnly" className="form-control" onChange={ () => this.toggleDisplayMode() } checked={ displayMode === 'imyOnly' } />
                View IMYs only
              </label>
              { displayWithholdingOption && <label className="form-label" htmlFor="showWithholding">
                <input id="showWithholding" type="checkbox" name="showWithholding" value="true" className="form-control" onChange={ () => this.toggleShowWithholding() } checked={ showWithholding } />
                Withholding Rates
              </label> }
            </div>
          </div>
        </div> }
        <AddFormModal
          isShown={ isAddFormModalShown }
          onConfirmUpload={ (parentForm, values) => this.addForms(parentForm, values, false) }
          onCancel={ () => this.closeAddFormModal() }
        />
        <DeleteFormModal
          isShown={ isDeleteFormModalShown }
          isDeletingForm={ isDeletingForm }
          onConfirmDelete={ () => this.deleteForm() }
          onCancel={ () => this.closeDeleteFormModal() }
          deleteFormError={ deleteFormError }
        />
        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }
        {(data != null) && <ReactSortableTree
          treeData={ data }
          onChange={ newData => this.setState({ data: newData }) }
          rowHeight={ this.getRowHeight() }
          canDrag={ false }
          searchQuery=""
          generateNodeProps={ (rowInfo) => {
            let cssStyles = '';
            if (rowInfo.node.name === 'Unknown Recipient') {
              cssStyles = 'rst__unknownRecipientNode';
            } else if (rowInfo.node.workflowPhase === 'initial') {
              cssStyles = 'rst__initialWorkflowNode';
            } else if (rowInfo.node.workflowPhase === 'secondary') {
              cssStyles = 'rst__secondaryWorkflowNode';
            } else if (rowInfo.node.valid !== true) {
              cssStyles = 'rst__invalidNode';
            } else if (rowInfo.node.canAddLayers === true || (rowInfo.node.formType != null && rowInfo.node.formType.startsWith('w8imy'))) {
              cssStyles = 'rst__branchNode';
            }
            const nodeProps = {
              className: `rst__leafNode ${ cssStyles }`,
              onClick: (e) => {
                if (e.target && e.target.className && e.target.className === 'rst__rowTitleItem' && rowInfo.node.id) {
                  this.onTitleClick(rowInfo.node);
                }
              },
              buttons: []
            };

            if (rowInfo.node.id != null) {
              if (rowInfo.node.canAddLayers === true) {
                nodeProps.className = `${ cssStyles }`;
                nodeProps.buttons = [
                  <button
                    type="button"
                    className="taina-icon taina-icon-sm add"
                    onClick={ () => this.openAddFormModal(rowInfo.node) }
                  />,
                  <button
                    type="button"
                    className="taina-icon taina-icon-sm delete"
                    onClick={ () => this.openDeleteFormModal(rowInfo.node) }
                  />
                ];
              } else {
                nodeProps.buttons = [
                  <button
                    type="button"
                    className="taina-icon taina-icon-sm delete"
                    onClick={ () => this.openDeleteFormModal(rowInfo.node) }
                  />
                ];
              }
            } else if (rowInfo.node.formType != null && rowInfo.node.formType.startsWith('w8imy')) {
              nodeProps.className = ` ${ cssStyles }`;
            }

            return nodeProps;
          } }
        />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions,
      settings
    },
    forms: {
      isAddFormModalShown,
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      deleteFormResponse,
      formsToDelete,
      showRate
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    }
  } = state;

  return {
    permissions,
    settings,
    isAddFormModalShown,
    isDeleteFormModalShown,
    isDeletingForm,
    deleteFormError,
    deleteFormResponse,
    formsToDelete,
    isOwnershipModalShown,
    changeOwnershipItem,
    showRate
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(VisualiseW8Imy, 'VisualiseW8Imy')));
